import script from "./DownloadApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadApp.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadApp.vue?vue&type=style&index=0&id=22cbc1ee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22cbc1ee"]])

export default __exports__